import Column from './Column'

export default Column



// WEBPACK FOOTER //
// ./src/components/Grid/Column/index.js